<template>
    <v-container grid-list-md fluid>
        <!-- // // /////////////////////////////////////////
        // // //// EN ATTENTE CONFIRMATION CHRISTINE
        // // //// DES COMPTES A SELECTIONNER
        // // ///////////////////////////////////////////// -->

        <!-- // ///////////////////////////////////////////
        // // //// IMPOSSIBLE DE MODIFIER LES DATES DE LA PROVISION SUR TAXES
        // // //// SANS DEMANDER LE DETAIL DES SB PAR SALARIE
        // // //// ///////////////////////////////////////// -->
        <v-row no-gutters class="d-flex justify-space-between mb-1">
            <v-col cols="7" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11">
                        <h2>Provisions sur salaires</h2>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>

            <v-col cols="5">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>
                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click.stop="dialog = true"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="closedPeriod || loading || dataLoading || !accountingPeriod"
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                createPaidHolidaysProvision('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                createPaidHolidaysProvision('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <v-list-item
                                :disabled="
                                    closedPeriod || !auditCheckResult || !auditCheckResult.id
                                "
                                @click="deleteAuditCheckResult(auditCheckResult.id)"
                            >
                                <v-list-item-title> Supprimer le contrôle </v-list-item-title>

                                <template v-slot:append>
                                    <v-icon size="small"> $oss-trash </v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>
        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="border-radius: 25px; margin-top: 10px"
                    class="bg-primary-foreground"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <!-- // ++ tables -->
            <template v-else>
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <v-row no-gutters v-if="noResults">
                    <v-col>
                        <v-card-title
                            style="padding-left: 102px; padding-top: 0"
                            class="text-primary"
                        >
                            <h4>Aucune écriture enregistrée sur l'exercice fiscal sélectionné</h4>
                        </v-card-title>
                    </v-col>
                </v-row>

                <v-row
                    no-gutters
                    v-else
                    style="padding-left: 24px; padding-right: 24px"
                    class="py-4"
                >
                    <v-col cols="auto" class="mr-auto">
                        <h3>
                            Salaire brut :
                            {{ newCommonFormatCurrency(globalsGrossWages, undefined) }}
                        </h3>
                    </v-col>

                    <v-col cols="auto" class="mx-auto">
                        <h3>
                            Charges sociales (patronales) :
                            {{ newCommonFormatCurrency(globalsEmployersContributions, undefined) }}
                        </h3>
                    </v-col>

                    <v-col cols="auto" class="mx-auto">
                        <h3>% moyen : {{ globalRateEmployersContribution }} %</h3>
                    </v-col>

                    <v-col cols="auto" class="ml-auto">
                        <h3>Base taxes : {{ newCommonFormatCurrency(taxeBasis, undefined) }}</h3>
                    </v-col>
                </v-row>

                <!-- // +++++++++++ EMPLOYEES' TABLE ++++++++++ -->
                <v-card
                    v-if="!noResults"
                    elevation="0"
                    style="border-radius: 25px"
                    class="pa-6 mt-4 bg-primary-foreground"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Liste des salariés et calcul des provisions</h5>
                            </v-card-title>
                        </v-col>

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <v-icon v-if="validatedPayrolls" color="primary">
                                        $fa-check-circle
                                    </v-icon>
                                </v-col>
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-btn-icon
                                        :icon="showPayrolls ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showPayrolls = !showPayrolls"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="showPayrolls" transition="expand">
                        <v-data-table
                            :headers="employeesListHeaders"
                            :items="employees"
                            :sort-by="[{ key: 'employee', order: false }]"
                            :sort-desc="[false, true]"
                            :loading="loading"
                            class="table"
                            style="border: 1px #ededed solid"
                        >
                            <!-- // ***** singles tooltips on headers -->
                            <!-- // ***** add hide-default-header after :headers  -->
                            <template v-slot:header="{ props: { headers } }">
                                <thead>
                                    <tr>
                                        <th v-for="(h, index) in headers" :key="index">
                                            <v-tooltip location="bottom">
                                                <!-- // ** v-if : tooltip on-->
                                                <template
                                                    v-if="
                                                        h.text === 'SN' ||
                                                        h.text === 'Estimés Réels' ||
                                                        h.text === 'SB' ||
                                                        h.text === 'CS' ||
                                                        h.text === 'CP acquis N' ||
                                                        h.text === '%' ||
                                                        h.text === '1 CP' ||
                                                        h.text === 'Prov. CP/RTT'
                                                    "
                                                    v-slot:activator="{ props }"
                                                >
                                                    <span v-bind="props">{{ h.text }}</span>
                                                </template>

                                                <!-- // ** v-else : tooltip off-->
                                                <template v-else v-slot:activator="{ props }">
                                                    <span v-bind="props">{{ h.text }}</span>
                                                </template>

                                                <!-- // ** tooltip text -->
                                                <span v-if="h.text === 'SN'">
                                                    Salaires nets réels
                                                </span>

                                                <span v-if="h.text === 'Estimés Réels'">
                                                    <p>
                                                        Estimé est adapté à des salariés présents
                                                        sur des mois entiers, tous avec, environ,
                                                        les même taux de cotisations patronales (pas
                                                        d'apprentis).
                                                    </p>
                                                    <p>
                                                        Réel rend nécessaire la saisie des 3 champs
                                                        affichés.
                                                    </p>
                                                </span>

                                                <span v-if="h.text === 'SB'">
                                                    Salaires bruts estimés ou réels
                                                </span>

                                                <span v-if="h.text === 'CS'">
                                                    Cotisations sociales patronales
                                                </span>

                                                <span v-if="h.text === 'CP acquis N'">
                                                    Congés payés acquis pendant la période calculée
                                                </span>

                                                <span v-if="h.text === '%'">
                                                    Taux de cotisations patronales, selon l'option
                                                    choisie : estimé ou réel
                                                </span>

                                                <span v-if="h.text === '1 CP'">
                                                    Valeur unitaire d'un jour de congé payé, calculé
                                                    selon la méthode du 10%
                                                </span>

                                                <span v-if="h.text === 'Prov. CP/RTT'">
                                                    Calcul au 10%
                                                </span>
                                            </v-tooltip>
                                        </th>
                                    </tr>
                                </thead>
                            </template>

                            <template #no-data>
                                Aucun bulletin de salaire saisi au cours de l'exercice
                            </template>

                            <template v-slot:item="props">
                                <tr>
                                    <!-- // ** Salariés -->
                                    <td
                                        v-if="props.item.employee"
                                        style="font-weight: bold; border-right: 1px solid #dddddd"
                                        class="pa-1"
                                    >
                                        {{ props.item.employee.lastName }}
                                        {{ props.item.employee.firstName }}
                                    </td>
                                    <td v-else class="pa-1">-</td>

                                    <!-- // ** Salaires Nets - REELS -->
                                    <td
                                        v-if="props.item.netSalarySum"
                                        style="
                                            font-weight: bold;
                                            text-align: right;
                                            border-right: 1px solid #dddddd;
                                        "
                                        class="pa-1"
                                    >
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.netSalarySum,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td v-else style="text-align: right" class="pa-1">-</td>

                                    <!-- // ** approxOrRealSwitch -->
                                    <td style="width: 24px" class="text-center pa-1">
                                        <v-checkbox
                                            v-model="props.item.approxOrRealSwitch"
                                            :disabled="props.item.validated"
                                            dense
                                            color="primary"
                                            hide-details
                                            width="24px"
                                            class="d-inline-flex pa-0 ma-0"
                                            @change="changeProvision(props.item)"
                                        />
                                        <!-- </div>
                                            </template>
    <span>En cas de saisie réelle, les 3 champs SB + CS + CP acquis N sont obligatoires</span> -->
                                        <!-- </v-tooltip> -->
                                    </td>

                                    <!-- // ** Salaires Bruts -->
                                    <td v-if="props.item.approxOrRealSwitch" class="pa-1">
                                        <oss-text-field-filled
                                            v-model="props.item.realGrossWages"
                                            :disabled="props.item.validated"
                                            :rules="[(v) => parseFloat(v) > 0 || 'Min 0']"
                                            @update:model-value="changeProvision(props.item)"
                                            style="
                                                margin-right: auto;
                                                margin-left: auto;
                                                display: inline-block;
                                                width: 100px;
                                                text-align: right;
                                            "
                                            content-class="text_field_tag"
                                            autofocus
                                            required
                                            :suffix="''"
                                            :hideDetails="false"
                                        >
                                        </oss-text-field-filled>
                                    </td>

                                    <td
                                        v-else-if="props.item.grossWagesApprox"
                                        style="min-width: 100px"
                                        class="text-right pa-1"
                                    >
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.grossWagesApprox,
                                                undefined,
                                            )
                                        }}
                                    </td>

                                    <!-- // ** Cotis patron - REELS -->
                                    <td
                                        v-if="props.item.approxOrRealSwitch"
                                        style="text-align: right"
                                        class="pa-1"
                                    >
                                        <!--  // ** :rules - add :hideDetails="false" -->
                                        <oss-text-field-filled
                                            v-model="props.item.realEmployerContributions"
                                            :disabled="props.item.validated"
                                            :rules="[(v) => parseFloat(v) > 0 || 'Min 0']"
                                            @update:model-value="changeProvision(props.item)"
                                            style="
                                                margin-right: auto;
                                                margin-left: auto;
                                                display: inline-block;
                                                width: 100px;
                                                text-align: right;
                                            "
                                            content-class="text_field_tag"
                                            autofocus
                                            required
                                            :suffix="''"
                                            :hideDetails="false"
                                        >
                                        </oss-text-field-filled>
                                    </td>
                                    <td v-else style="text-align: right" class="pa-1">-</td>

                                    <!-- // ** CP acquis - REELS -->
                                    <td
                                        v-if="props.item.approxOrRealSwitch"
                                        style="text-align: center; border-right: 1px solid #dddddd"
                                        class="pa-1"
                                    >
                                        <oss-text-field-filled
                                            v-model="props.item.realEarnedPaidHolidays"
                                            :disabled="props.item.validated"
                                            style="
                                                margin-right: auto;
                                                margin-left: auto;
                                                width: 60px;
                                            "
                                            min="0"
                                            max="60"
                                            content-class="text_field_tag"
                                            autofocus
                                            :rules="[(v) => parseFloat(v) > 0 || 'Min 0']"
                                            @update:model-value="changeProvision(props.item)"
                                            required
                                        >
                                        </oss-text-field-filled>
                                    </td>
                                    <td
                                        v-else
                                        style="text-align: right; border-right: 1px solid #dddddd"
                                        class="pa-1"
                                    >
                                        -
                                    </td>

                                    <!-- // ** Apprentis -->
                                    <td class="text-center pa-1">
                                        <v-checkbox
                                            v-model="props.item.apprentice"
                                            :disabled="props.item.validated"
                                            color="primary"
                                            hide-details
                                            class="d-inline-flex pa-0 ma-0"
                                            @change="changeTaxesProvision()"
                                        />
                                    </td>

                                    <!-- // ** Taux utilisé -->
                                    <td
                                        v-if="props.item.usedRate"
                                        style="
                                            font-weight: bold;
                                            text-align: right;
                                            border-right: 1px solid #dddddd;
                                        "
                                        class="pa-1"
                                    >
                                        {{ props.item.usedRate }}%
                                    </td>
                                    <td
                                        v-else
                                        style="text-align: right; border-right: 1px solid #dddddd"
                                        class="pa-1"
                                    >
                                        -
                                    </td>

                                    <!-- // ** Jrs ouvrables 30/ouvrés 25 -->
                                    <!-- // ** if !props.item.approxOrRealSwitch > v-select -->
                                    <td
                                        v-if="
                                            props.item.daysTypes && !props.item.approxOrRealSwitch
                                        "
                                        class="pa-1 align-center"
                                    >
                                        <v-select-filled
                                            v-model="props.item.daysTypes"
                                            :disabled="props.item.validated"
                                            :items="workingBusinessDays"
                                            style="width: 90px"
                                            required
                                            @update:model-value="changeProvision(props.item)"
                                            density="compact"
                                        />
                                    </td>
                                    <td v-else style="text-align: right" class="pa-1">
                                        <!-- // ** if props.item.approxOrRealSwitch : -->
                                        <!-- // ** oneDayGrossWage = SB * 10% / CP acquis  -->
                                    </td>

                                    <!-- // ** Valeur SB 1jr -->
                                    <td v-if="props.item.oneDayGrossWage">
                                        <template
                                            v-if="
                                                props.item.approxOrRealSwitch &&
                                                (!props.item.realGrossWages ||
                                                    !props.item.realEmployerContributions ||
                                                    !props.item.realEarnedPaidHolidays)
                                            "
                                            style="color: red; text-align: right"
                                            class="pa-1"
                                        >
                                            <v-tooltip
                                                location="bottom"
                                                text="En cas de saisie réelle, les 3 champs SB + CS + CP
                                                    acquis N sont nécessaires au calcul"
                                            >
                                                <template
                                                    v-slot:activator="{ props: tooltipProps }"
                                                >
                                                    <span v-bind="tooltipProps">-</span>
                                                </template>
                                            </v-tooltip>
                                        </template>

                                        <template
                                            v-else-if="props.item.approxOrRealSwitch"
                                            style="text-align: right"
                                            class="pa-1"
                                        >
                                            <v-tooltip
                                                location="bottom"
                                                text="SB réel * 10% / CP acquis"
                                            >
                                                <template
                                                    v-slot:activator="{ props: tooltipProps }"
                                                >
                                                    <span v-bind="tooltipProps">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item.oneDayGrossWage,
                                                                undefined,
                                                            )
                                                        }}
                                                    </span>
                                                </template>
                                            </v-tooltip>
                                        </template>

                                        <template v-else style="text-align: right" class="pa-1">
                                            <v-tooltip
                                                location="bottom"
                                                text="SB approx * 10% / (nb bulletins / 12) / (25 ou
                                                    30)"
                                            >
                                                <template
                                                    v-slot:activator="{ props: tooltipProps }"
                                                >
                                                    <span v-bind="tooltipProps">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                props.item.oneDayGrossWage,
                                                                undefined,
                                                            )
                                                        }}
                                                    </span>
                                                </template>
                                            </v-tooltip>
                                        </template>
                                    </td>

                                    <td v-else style="text-align: right" class="pa-1">-</td>

                                    <!-- // ** Solde Congés Payés -->
                                    <td
                                        v-if="props.item.balancePaidHolidays >= 0"
                                        style="text-align: center"
                                        class="pa-1"
                                    >
                                        <oss-text-field-filled
                                            v-model="props.item.balancePaidHolidays"
                                            :disabled="props.item.validated"
                                            style="
                                                margin-right: auto;
                                                margin-left: auto;
                                                width: 60px;
                                            "
                                            min="0"
                                            max="60"
                                            :error="props.item.balancePaidHolidays < 0"
                                            content-class="text_field_tag"
                                            autofocus
                                            @change="changeProvision(props.item)"
                                        >
                                        </oss-text-field-filled>
                                    </td>
                                    <td v-else style="text-align: center" class="pa-1">-</td>

                                    <!-- // ** Solde RTT -->
                                    <td
                                        v-if="props.item.balanceRTT >= 0"
                                        style="text-align: center"
                                        class="pa-1"
                                    >
                                        <oss-text-field-filled
                                            v-model="props.item.balanceRTT"
                                            :disabled="props.item.validated"
                                            style="
                                                margin-right: auto;
                                                margin-left: auto;
                                                width: 60px;
                                            "
                                            min="0"
                                            max="60"
                                            :error="props.item.balanceRTT < 0"
                                            content-class="text_field_tag"
                                            autofocus
                                            @change="changeProvision(props.item)"
                                        >
                                        </oss-text-field-filled>
                                    </td>
                                    <td v-else style="text-align: center" class="pa-1">-</td>

                                    <!-- // ** Provisions : 10% salaire Brut-->
                                    <td
                                        v-if="props.item.grossWageProvision"
                                        style="font-weight: bold; text-align: right"
                                        class="pa-1"
                                    >
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.grossWageProvision,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td v-else style="text-align: right" class="pa-1">-</td>

                                    <!-- // ** Provisions : charges patronales s/CP + RTT -->
                                    <td
                                        v-if="props.item.employerContribProvOnGrossWage"
                                        style="
                                            font-weight: bold;
                                            text-align: right;
                                            border-right: 1px solid #dddddd;
                                        "
                                        class="pa-1"
                                    >
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.employerContribProvOnGrossWage,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td
                                        v-else
                                        style="text-align: right; border-right: 1px solid #dddddd"
                                        class="pa-1"
                                    >
                                        -
                                    </td>

                                    <!-- // ** Primes -->
                                    <td
                                        v-if="props.item.bonus >= 0"
                                        style="text-align: right"
                                        class="pa-1"
                                    >
                                        <oss-text-field-filled
                                            v-model="props.item.bonus"
                                            :disabled="props.item.validated"
                                            style="
                                                width: 100px;
                                                margin-right: auto;
                                                margin-left: auto;
                                            "
                                            min="0"
                                            :error="props.item.bonus < 0"
                                            content-class="text_field_tag"
                                            autofocus
                                            :suffix="''"
                                            @change="changeProvision(props.item)"
                                        >
                                        </oss-text-field-filled>
                                    </td>
                                    <td v-else style="text-align: right" class="pa-1">-</td>

                                    <!-- // ** Provisions : charges patronales s/primes-->
                                    <td
                                        v-if="props.item.employerContribProvOnBonus"
                                        style="font-weight: bold; text-align: right"
                                        class="pa-1"
                                    >
                                        {{
                                            newCommonFormatCurrency(
                                                props.item.employerContribProvOnBonus,
                                                undefined,
                                            )
                                        }}
                                    </td>
                                    <td v-else style="text-align: right" class="pa-1">-</td>

                                    <!-- // ** Validate -->
                                    <td class="text-center pa-1">
                                        <v-checkbox
                                            v-model="props.item.validated"
                                            :disabled="validatedPayrolls || validated"
                                            color="primary"
                                            hide-details
                                            class="d-inline-flex pa-0 ma-0"
                                            @change="changeTaxesProvision()"
                                        />
                                    </td>
                                </tr>
                            </template>
                            <template #body.append>
                                <tr style="font-weight: bold; color: black">
                                    <th style="text-align: left; border-right: 1px solid #dddddd">
                                        Totaux
                                    </th>

                                    <th style="text-align: right; border-right: 1px solid #dddddd">
                                        {{
                                            newCommonFormatCurrency(
                                                sumField("netSalarySum"),
                                                undefined,
                                            )
                                        }}
                                    </th>

                                    <th />

                                    <th style="text-align: right">
                                        {{
                                            newCommonFormatCurrency(
                                                sumFieldGrossWages("approxOrRealSwitch"),
                                                undefined,
                                            )
                                        }}
                                    </th>

                                    <th style="text-align: right">
                                        {{
                                            newCommonFormatCurrency(
                                                sumFieldEmployerContributions("approxOrRealSwitch"),
                                                undefined,
                                            )
                                        }}
                                    </th>

                                    <th style="border-right: 1px solid #dddddd" />

                                    <th />
                                    <th />
                                    <th />
                                    <th />

                                    <th style="text-align: center">
                                        {{ sumField("balancePaidHolidays") }}
                                    </th>

                                    <th style="text-align: center">
                                        {{ sumField("balanceRTT") }}
                                    </th>

                                    <th style="text-align: right">
                                        {{
                                            newCommonFormatCurrency(
                                                sumField("grossWageProvision"),
                                                undefined,
                                            )
                                        }}
                                    </th>

                                    <th style="text-align: right; border-right: 1px solid #dddddd">
                                        {{
                                            newCommonFormatCurrency(
                                                sumField("employerContribProvOnGrossWage"),
                                                undefined,
                                            )
                                        }}
                                    </th>

                                    <th style="text-align: right">
                                        {{ newCommonFormatCurrency(sumField("bonus"), undefined) }}
                                    </th>

                                    <th style="text-align: right">
                                        {{
                                            newCommonFormatCurrency(
                                                sumField("employerContribProvOnBonus"),
                                                undefined,
                                            )
                                        }}
                                    </th>

                                    <th />
                                </tr>
                            </template>
                        </v-data-table>
                        <!-- // +++++++++++++++ textarea ++++++++++++++++ -->
                        <v-row>
                            <v-col class="pb-5">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-space-between"
                                >
                                    <h5>Commentaires</h5>

                                    <div class="d-flex justify-end">
                                        <v-btn
                                            :disabled="
                                                validatedPayrolls || closedPeriod || validated
                                            "
                                            @click="miscellaneousOperationDialog = true"
                                            size="small"
                                        >
                                            OD
                                        </v-btn>

                                        <v-btn
                                            :disabled="
                                                validatedPayrolls || closedPeriod || validated
                                            "
                                            class="ml-2"
                                            @click.stop="dialog = true"
                                            size="small"
                                        >
                                            Enregistrer
                                        </v-btn>

                                        <v-btn
                                            v-if="!validatedPayrolls"
                                            :disabled="closedPeriod || validated"
                                            class="ml-2"
                                            @click="
                                                validatedPayrolls = !validatedPayrolls;
                                                createPaidHolidaysProvision('VALIDATE');
                                            "
                                            size="small"
                                        >
                                            Valider les salariés
                                        </v-btn>

                                        <v-btn
                                            v-else
                                            v-model="validatedPayrolls"
                                            :disabled="closedPeriod || validated"
                                            class="ml-2"
                                            @click="invalidate()"
                                            size="small"
                                        >
                                            Invalider les salariés
                                        </v-btn>
                                    </div>
                                </v-card-title>
                            </v-col>
                        </v-row>

                        <v-row no-gutters style="padding-top: 0">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="commentEmployees"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                    />
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // +++++++++++ TAXES ++++++++++ -->
                <v-card
                    v-if="!noResults"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Taxes</h5>
                            </v-card-title>
                        </v-col>

                        <!-- // ** taxes - expand *************** -->
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <v-icon v-if="validatedTaxes" color="primary">
                                        $fa-check-circle
                                    </v-icon>
                                </v-col>
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-btn-icon
                                        :icon="showTaxes ? '$fa-chevron-up' : '$fa-chevron-down'"
                                        @click="showTaxes = !showTaxes"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <!-- // ** taxes - expand open *************** -->
                    <v-card-text v-show="showTaxes" transition="expand">
                        <v-card-title class="pa-0">
                            <v-row no-gutters>
                                <v-col class="d-flex align-center">
                                    <v-card-title class="px-0">
                                        <!-- <h4 v-if="accountingPeriod && accountingPeriod.start && accountingPeriod.end && differentsDates">
                                            Période du {{formatDate(dates[0])}} au {{formatDate(dates[1])}}
                                        </h4>
                                        <h4 v-else-if="accountingPeriod && accountingPeriod.start && accountingPeriod.end">
                                            Période du {{formatDate(accountingPeriod.start)}} au {{formatDate(accountingPeriod.end)}}
                                        </h4> -->

                                        <h4
                                            v-if="dates.length === 2 && differentsDates"
                                            class="d-flex align-center"
                                        >
                                            Période de calcul des taxes s/salaires : du
                                            {{ formatDate(dates[0]) }} au {{ formatDate(dates[1]) }}
                                        </h4>
                                        <h4
                                            v-else-if="
                                                accountingPeriod &&
                                                accountingPeriod.start &&
                                                accountingPeriod.end
                                            "
                                            class="d-flex align-center"
                                        >
                                            Période du {{ formatDate(accountingPeriod.start) }} au
                                            {{ formatDate(accountingPeriod.end) }}
                                        </h4>
                                    </v-card-title>
                                </v-col>

                                <v-col class="d-flex align-center pl-2">
                                    <!-- // ** oss-date-range-picker don't works -->
                                    <!-- <oss-date-range-picker
                                        :begin="dates[0]"
                                        :end="dates[1]"
                                        @change-dateRange="onDateRangeChanged; changeTaxesProvision()"
                                        :outlined="true"
                                        :hideDetails="true"
                                        dense
                                    ></oss-date-range-picker> -->

                                    <!-- // ** don't works -->
                                    <!-- <oss-date-range-picker
                                        v-model="dates"
                                        :begin="dates[0]"
                                        :end="dates[1]"
                                        @change-dateRange="changeTaxesProvision()"
                                        :outlined="true"
                                        :hide-details="true"
                                        dense
                                    >
                                    </oss-date-range-picker> -->

                                    <!-- // ** works, but ugly -->
                                    <!-- <v-date-picker
                                        v-model="dates"
                                        range
                                        @change="changeTaxesProvision()"
                                    ></v-date-picker> -->

                                    <!-- // ** works -->
                                    <v-menu
                                        ref="datesShow"
                                        v-model="datesShow"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template v-slot:activator="{ props }">
                                            <v-btn v-bind="props" icon="$oss-calendar"> </v-btn>
                                        </template>

                                        <oss-date-range-picker
                                            :begin="dates[0]"
                                            :end="dates[1]"
                                            :disabled="closedPeriod || validated"
                                            @change-dateRange="onDateRangeChanged"
                                            :hideDetails="true"
                                        >
                                            <v-spacer />
                                        </oss-date-range-picker>
                                    </v-menu>
                                </v-col>

                                <v-col class="d-flex align-center">
                                    <h5
                                        v-if="
                                            globalsGrossWages &&
                                            dates &&
                                            dates[0] === formatDatePicker(accountingPeriod.start) &&
                                            dates[1] === formatDatePicker(accountingPeriod.end)
                                        "
                                    >
                                        SB :
                                        {{ newCommonFormatCurrency(globalsGrossWages, undefined) }}
                                    </h5>
                                    <h5 v-else class="text-primary">
                                        SB période :
                                        {{
                                            newCommonFormatCurrency(
                                                taxesPeriodGrossWages,
                                                undefined,
                                            )
                                        }}
                                    </h5>
                                </v-col>

                                <v-col cols="auto" class="d-flex align-center">
                                    <h5>
                                        Base taxes (SB - SB apprentis) :
                                        {{ newCommonFormatCurrency(taxeBasis, undefined) }}
                                    </h5>
                                </v-col>
                            </v-row>
                        </v-card-title>

                        <!-- // ** no Apprentis -->
                        <v-card-text class="pa-0" v-if="!newPeriodApprentices">
                            <v-row class="pt-4 pb-6">
                                <v-col style="padding-top: 0; padding-bottom: 0">
                                    <v-card-title class="px-0">
                                        <h4 class="text-primary">Pas d'apprentis sur la période</h4>
                                    </v-card-title>
                                </v-col>
                            </v-row>
                        </v-card-text>

                        <!-- // ** Apprentis table -->
                        <v-card-text class="pa-0" v-else>
                            <v-data-table
                                :headers="apprenticesHeaders"
                                :items="employees"
                                :sort-by="[{ key: 'employee', order: false }]"
                                :sort-desc="[false, true]"
                                :loading="loading"
                                class="table"
                                style="border: 1px #ededed solid"
                            >
                                <template #no-data
                                    >Aucun bulletin de salaire saisi au cours de
                                    l'exercice</template
                                >
                                <!-- hide-default-header -->

                                <template v-slot:item="props">
                                    <tr v-if="props.item.apprentice">
                                        <!-- // ** Salariés -->
                                        <td
                                            v-if="props.item.employee"
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                            class="pa-1"
                                        >
                                            {{ props.item.employee.lastName }}
                                            {{ props.item.employee.firstName }}
                                        </td>

                                        <!-- // ** Salaires Bruts - REELS -->
                                        <td
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                            class="pa-1"
                                        >
                                            <oss-text-field-filled
                                                v-model="props.item.grossWageInNewPeriod"
                                                :disabled="validatedTaxes"
                                                style="
                                                    margin-right: auto;
                                                    margin-left: auto;
                                                    display: inline-block;
                                                    width: 100px;
                                                    text-align: right;
                                                "
                                                content-class="text_field_tag"
                                                autofocus
                                                :rules="[(v) => parseFloat(v) > 0 || 'Min 0']"
                                                required
                                                :suffix="''"
                                                :hideDetails="false"
                                                @update:model-value="changeTaxesProvision()"
                                            >
                                            </oss-text-field-filled>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card-text>

                        <v-card-title class="pa-0">
                            <v-row class="pb-4">
                                <v-col>
                                    <v-switch
                                        v-model="taxeApprentissage"
                                        :disabled="closedPeriod || validated"
                                        :label="`Taxe Apprentissage`"
                                        style="text-center"
                                        class="ml-2"
                                        @change="changeTaxesProvision()"
                                    />
                                </v-col>

                                <v-col>
                                    <v-switch
                                        v-model="taxeSurLesSalaires"
                                        :disabled="closedPeriod || validated"
                                        :label="'Taxe Salaires'"
                                        style="text-center"
                                        class="ml-2"
                                        @change="changeTaxesProvision()"
                                    />
                                </v-col>

                                <v-col>
                                    <v-switch
                                        v-model="contributionUniqueALaFormation"
                                        :disabled="closedPeriod || validated"
                                        :label="'Contrib. Unique Formation'"
                                        style="text-center"
                                        class="ml-2"
                                        @change="changeTaxesProvision()"
                                    />
                                </v-col>

                                <v-col>
                                    <v-switch
                                        v-model="contributionEffortConstruction"
                                        :disabled="closedPeriod || validated"
                                        :label="`Contrib. Effort Constr.`"
                                        style="text-center"
                                        class="ml-2"
                                        @change="changeTaxesProvision()"
                                    />
                                </v-col>
                            </v-row>
                        </v-card-title>

                        <v-card-title
                            v-if="
                                taxeApprentissage === true ||
                                taxeSurLesSalaires === true ||
                                contributionUniqueALaFormation === true ||
                                contributionEffortConstruction === true
                            "
                            class="pa-0"
                        >
                            <v-row class="pb-2">
                                <v-col v-if="taxeApprentissage === true" class="mr-4">
                                    <!-- // ** taxeApprentissageRate -->
                                    <v-row>
                                        <v-col>
                                            <oss-text-field-filled
                                                v-model="taxeApprentissageRate"
                                                :disabled="closedPeriod || validated"
                                                suffix="%"
                                                label="Taxe d'Apprentissage"
                                                class="mx-auto"
                                                content-class="text_field_tag"
                                                autofocus
                                                @change="changeTaxesProvision()"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(
                                                    taxeApprentissageAmount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <!-- // ** contributionSupplementaireALApprentissageRate -->
                                    <v-row>
                                        <v-col>
                                            <oss-text-field-filled
                                                v-model="
                                                    contributionSupplementaireALApprentissageRate
                                                "
                                                :disabled="closedPeriod || validated"
                                                suffix="%"
                                                label="Contr. Suppl. Apprent."
                                                class="mx-auto"
                                                content-class="text_field_tag"
                                                autofocus
                                                @change="changeTaxesProvision()"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(
                                                    contributionSupplementaireALApprentissageAmount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else />

                                <!-- // ** taxeSurLesSalairesRate -->
                                <v-col v-if="taxeSurLesSalaires === true" class="mx-4">
                                    <v-row>
                                        <v-col>
                                            <oss-text-field-filled
                                                v-model="taxeSurLesSalairesRate"
                                                :disabled="closedPeriod || validated"
                                                suffix="%"
                                                label="Taxe sur les Salaires"
                                                class="mx-auto"
                                                content-class="text_field_tag"
                                                autofocus
                                                @change="changeTaxesProvision()"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(
                                                    taxeSurLesSalairesAmount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else />

                                <!-- // ** contributionUniqueALaFormationRate -->
                                <v-col v-if="contributionUniqueALaFormation === true" class="mx-4">
                                    <v-row>
                                        <v-col>
                                            <oss-text-field-filled
                                                v-model="contributionUniqueALaFormationRate"
                                                :disabled="closedPeriod || validated"
                                                suffix="%"
                                                label="Contr. Unique Formation"
                                                class="mx-auto"
                                                content-class="text_field_tag"
                                                autofocus
                                                @change="changeTaxesProvision()"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(
                                                    contributionUniqueALaFormationAmount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else />

                                <!-- // ** contributionEffortConstructionRate -->
                                <v-col v-if="contributionEffortConstruction === true" class="ml-4">
                                    <v-row>
                                        <v-col>
                                            <oss-text-field-filled
                                                v-model="contributionEffortConstructionRate"
                                                :disabled="closedPeriod || validated"
                                                suffix="%"
                                                label="Contr. Effort Construct."
                                                class="mx-auto"
                                                content-class="text_field_tag"
                                                autofocus
                                                @change="changeTaxesProvision()"
                                            >
                                            </oss-text-field-filled>
                                        </v-col>
                                        <v-col class="d-flex justify-end align-center">
                                            {{
                                                newCommonFormatCurrency(
                                                    contributionEffortConstructionAmount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else />
                            </v-row>
                        </v-card-title>

                        <!-- // +++++++++++++++ textarea + btns ++++++++++++++++ -->
                        <v-row>
                            <v-col class="pb-5">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <!-- <h5>
                                        Commentaires
                                    </h5> -->

                                    <v-spacer />

                                    <v-btn
                                        :disabled="closedPeriod || validatedTaxes || validated"
                                        rounded
                                        class="btn btn_blue"
                                        @click="miscellaneousOperationDialog = true"
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        :disabled="closedPeriod || validatedTaxes || validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click.stop="dialog = true"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <v-btn
                                        v-if="!validatedTaxes"
                                        v-model="validatedTaxes"
                                        :disabled="closedPeriod || validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validatedTaxes = !validatedTaxes;
                                            createPaidHolidaysProvision('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider les taxes
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        v-model="validatedTaxes"
                                        :disabled="closedPeriod || validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validatedTaxes = !validatedTaxes;
                                            createPaidHolidaysProvision('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider les taxes
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>

                        <!-- <v-row no-gutters style="padding-top: 0;">
                            <v-col style="padding-top: 0;">
                                <v-card-text style="padding: 0;">
                                    <v-textarea
                                        v-model="commentTaxes"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        outlined
                                        style="border: 1px #EDEDED solid;"
                                    ></v-textarea>
                                </v-card-text>
                            </v-col>
                        </v-row> -->
                    </v-card-text>
                </v-card>

                <!-- // ** connectedDocuments -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriod.id || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- // ** results -->
                <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ++ longComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <!-- <v-spacer></v-spacer> -->

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedTaxes"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            longCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="longCommentExpand = !longCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="longCommentExpand" transition="longCommentExpand">
                        <!-- <v-expand-transition no-gutters v-show="longCommentExpand"> -->
                        <v-card-text class="px-4">
                            <v-textarea
                                v-model="longComment"
                                :disabled="closedPeriod || validated"
                                auto-grow
                                style="border: 1px #ededed solid"
                            />
                        </v-card-text>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        :disabled="closedPeriod || validated"
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="createPaidHolidaysProvision()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ++ shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <!-- // ** title ************** -->
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <!-- // ** icons *************** -->
                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedTaxes"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>

                                <!-- // ** expand icon -->
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="shortCommentExpand">
                        <v-card-text class="px-4">
                            <v-textarea
                                v-model="shortComment"
                                :disabled="closedPeriod || validated"
                                auto-grow
                                style="border: 1px #ededed solid"
                            />
                        </v-card-text>

                        <v-row>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                >
                                    <v-spacer />

                                    <!-- // ** Store data -->
                                    <v-btn
                                        :disabled="closedPeriod || validated"
                                        rounded
                                        class="btn btn_blue"
                                        @click.stop="createPaidHolidaysProvision()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ++++++ GeneralLedger ********* -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row>
                        <v-col cols="11" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">
                                    Grand livre - c/{{
                                        getTextFromStringArray(auditItems.othersAccountableAccounts)
                                    }}
                                    {{
                                        auditItems.excludedOthersAccountableAccounts &&
                                        auditItems.excludedOthersAccountableAccounts.length
                                            ? `(sauf ${getTextFromStringArray(
                                                  auditItems.excludedOthersAccountableAccounts,
                                              )}`
                                            : ""
                                    }}
                                </h5>
                            </v-card-title>
                        </v-col>

                        <!-- <v-spacer></v-spacer> -->

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validatedTaxes"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            showGeneralLedger
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="showGeneralLedger = !showGeneralLedger"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-expand-transition>
                        <div v-show="showGeneralLedger">
                            <v-row class="pt-2">
                                <v-col
                                    style="padding-top: 0; padding-bottom: 0"
                                    :key="refreshGeneralLedger"
                                >
                                    <GeneralLedger
                                        :companyId="companyId"
                                        :accountingPeriodId="accountingPeriod.id"
                                        :hideOptions="false"
                                        :accountableAccountFilter="
                                            auditItems.othersAccountableAccounts || []
                                        "
                                        :excludedAccountableAccounts="
                                            auditItems.excludedOthersAccountableAccounts || []
                                        "
                                        :refreshCount="refreshGeneralLedger"
                                        v-if="accountingPeriod.id"
                                    />
                                    <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>

                <!-- // ++++++++ DIALOG - CHECK BOOK ENTRIES +++++++++++++ -->
                <!-- <v-dialog v-if="dialog" v-model="dialog" persistent min-width="90%">
                    <v-card>
                        <v-card-text>
                            <v-container>
                                <h1 v-if="wagesCond" style="margin-top: 15px; margin-bottom: 10px">
                                    PROVISIONS SUR SALAIRES
                                </h1>

                                <h2 v-else :style="styleDialogNoProvision">
                                    Aucune Provision s/Salaires
                                </h2>

                                <div v-if="wagesCond">
                                    <v-divider />

                                    <h2
                                        v-if="bookEntries.grossWageProvision.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions pour congés payés et RTT
                                    </h2>

                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision pour congés payés et RTT
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.grossWageProvision.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol"> Salaire Brut </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.grossWageProvision
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.grossWageProvision
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.grossWageProvision.amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.employerContribProvOnGrossWage.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol">
                                            Cotisations patronales
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.employerContribProvOnGrossWage
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.employerContribProvOnGrossWage
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.employerContribProvOnGrossWage
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </div>

                                <h2
                                    v-if="bookEntries.bonusGrossSalary.amount > 0"
                                    :style="styleDialogProvision"
                                >
                                    Provisions sur primes
                                </h2>

                                <h3 v-else :style="styleDialogNoProvision">
                                    Aucune provision sur primes
                                </h3>

                                <v-row no-gutters v-if="bookEntries.bonusGrossSalary.amount > 0">
                                    <v-col :style="styleDialogCol"> Salaire brut </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{ bookEntries.bonusGrossSalary.accountableAccountName }} à
                                        {{
                                            bookEntries.bonusGrossSalary
                                                .thirdPartyAccountableAccountName
                                        }}
                                    </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{
                                            newCommonFormatCurrency(
                                                bookEntries.bonusGrossSalary.amount,
                                                undefined,
                                            )
                                        }}
                                    </v-col>
                                </v-row>

                                <v-row
                                    no-gutters
                                    v-if="bookEntries.employerContribProvOnBonus.amount > 0"
                                >
                                    <v-col :style="styleDialogCol"> Cotisations patronales </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{
                                            bookEntries.employerContribProvOnBonus
                                                .accountableAccountName
                                        }}
                                        à
                                        {{
                                            bookEntries.employerContribProvOnBonus
                                                .thirdPartyAccountableAccountName
                                        }}
                                    </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{
                                            newCommonFormatCurrency(
                                                bookEntries.employerContribProvOnBonus.amount,
                                                undefined,
                                            )
                                        }}
                                    </v-col>
                                </v-row>

                                <v-divider :style="styleDialogDivider" />

                                <h1 v-if="taxesCond" style="margin-top: 40px; margin-bottom: 10px">
                                    TAXES SUR SALAIRES
                                </h1>
                                <h3 v-if="taxesCond" style="margin-top: 10px; margin-bottom: 5px">
                                    Base : SB Annuel - SB apprentis
                                </h3>
                                <h2 v-else style="color: #e1be7a">Aucune Taxe s/Salaires</h2>

                                <div v-if="taxesCond" class="pt-4">
                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.taxeApprentissage.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur taxe d'apprentissage
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur taxe d'apprentissage
                                    </h3>
                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.taxeApprentissage.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.taxeApprentissage.accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.taxeApprentissage
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.taxeApprentissage.amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="
                                            bookEntries.contributionSupplementaireALApprentissage
                                                .amount > 0
                                        "
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur la Contribution Supplementaire à
                                        l'Apprentissage
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur la Contribution Supplementaire à
                                        l'Apprentissage
                                    </h3>
                                    <v-row
                                        no-gutters
                                        v-if="
                                            bookEntries.contributionSupplementaireALApprentissage
                                                .amount > 0
                                        "
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries
                                                    .contributionSupplementaireALApprentissage
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries
                                                    .contributionSupplementaireALApprentissage
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries
                                                        .contributionSupplementaireALApprentissage
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.taxeSurLesSalaires.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur taxe sur les salaires
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur taxe sur les salaires
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.taxeSurLesSalaires.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.taxeSurLesSalaires
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.taxeSurLesSalaires
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.taxeSurLesSalaires.amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.contributionUniqueALaFormation.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur la Contribution Unique à la Formation
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur la Contribution Unique à la Formation
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.contributionUniqueALaFormation.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.contributionUniqueALaFormation
                                                    .accountableAccountName
                                            }}
                                            + 445860 à
                                            {{
                                                bookEntries.contributionUniqueALaFormation
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionUniqueALaFormation
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                            HT +
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionUniqueALaFormation
                                                        .vatAmount,
                                                    undefined,
                                                )
                                            }}
                                            TVA à
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionUniqueALaFormation
                                                        .grossAmount,
                                                    undefined,
                                                )
                                            }}
                                            TTC
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.contributionEffortConstruction.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur taxe d'apprentissage
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur la Contribution à l'Effort de la
                                        Construction
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.contributionEffortConstruction.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.contributionEffortConstruction
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.contributionEffortConstruction
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionEffortConstruction
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer />
                            <v-btn rounded depressed @click="closeDialog"> Annuler </v-btn>

                            <v-btn rounded depressed @click="createPaidHolidaysProvision()">
                                Enregistrer
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog> -->
                <oss-dialog
                    v-if="dialog"
                    v-model="dialog"
                    persistent
                    min-width="90vw"
                    @valid="createPaidHolidaysProvision()"
                    @close="closeDialog"
                >
                    <v-card>
                        <v-card-text>
                            <v-container>
                                <!-- // ++ provisions on wages ** -->
                                <h1 v-if="wagesCond" style="margin-top: 15px; margin-bottom: 10px">
                                    PROVISIONS SUR SALAIRES
                                </h1>

                                <h2 v-else :style="styleDialogNoProvision">
                                    Aucune Provision s/Salaires
                                </h2>

                                <div v-if="wagesCond">
                                    <v-divider />

                                    <!-- // ++ PaidHolidays ** -->
                                    <h2
                                        v-if="bookEntries.grossWageProvision.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions pour congés payés et RTT
                                    </h2>

                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision pour congés payés et RTT
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.grossWageProvision.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol"> Salaire Brut </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.grossWageProvision
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.grossWageProvision
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.grossWageProvision.amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.employerContribProvOnGrossWage.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol">
                                            Cotisations patronales
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.employerContribProvOnGrossWage
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.employerContribProvOnGrossWage
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.employerContribProvOnGrossWage
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </div>

                                <!-- // ++ Bonus ** -->
                                <h2
                                    v-if="bookEntries.bonusGrossSalary.amount > 0"
                                    :style="styleDialogProvision"
                                >
                                    Provisions sur primes
                                </h2>

                                <h3 v-else :style="styleDialogNoProvision">
                                    Aucune provision sur primes
                                </h3>

                                <v-row no-gutters v-if="bookEntries.bonusGrossSalary.amount > 0">
                                    <v-col :style="styleDialogCol"> Salaire brut </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{ bookEntries.bonusGrossSalary.accountableAccountName }} à
                                        {{
                                            bookEntries.bonusGrossSalary
                                                .thirdPartyAccountableAccountName
                                        }}
                                    </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{
                                            newCommonFormatCurrency(
                                                bookEntries.bonusGrossSalary.amount,
                                                undefined,
                                            )
                                        }}
                                    </v-col>
                                </v-row>

                                <v-row
                                    no-gutters
                                    v-if="bookEntries.employerContribProvOnBonus.amount > 0"
                                >
                                    <v-col :style="styleDialogCol"> Cotisations patronales </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{
                                            bookEntries.employerContribProvOnBonus
                                                .accountableAccountName
                                        }}
                                        à
                                        {{
                                            bookEntries.employerContribProvOnBonus
                                                .thirdPartyAccountableAccountName
                                        }}
                                    </v-col>

                                    <v-col :style="styleDialogCol">
                                        {{
                                            newCommonFormatCurrency(
                                                bookEntries.employerContribProvOnBonus.amount,
                                                undefined,
                                            )
                                        }}
                                    </v-col>
                                </v-row>

                                <v-divider :style="styleDialogDivider" />

                                <!-- // ++ TAXES ** -->
                                <h1 v-if="taxesCond" style="margin-top: 40px; margin-bottom: 10px">
                                    TAXES SUR SALAIRES
                                </h1>
                                <h3 v-if="taxesCond" style="margin-top: 10px; margin-bottom: 5px">
                                    Base : SB Annuel - SB apprentis
                                </h3>
                                <h2 v-else style="color: #e1be7a">Aucune Taxe s/Salaires</h2>

                                <div v-if="taxesCond" class="pt-4">
                                    <v-divider :style="styleDialogDivider" />

                                    <!-- // ++ Taxe d'apprentissage ** -->
                                    <h2
                                        v-if="bookEntries.taxeApprentissage.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur taxe d'apprentissage
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur taxe d'apprentissage
                                    </h3>
                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.taxeApprentissage.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.taxeApprentissage.accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.taxeApprentissage
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.taxeApprentissage.amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="
                                            bookEntries.contributionSupplementaireALApprentissage
                                                .amount > 0
                                        "
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur la Contribution Supplementaire à
                                        l'Apprentissage
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur la Contribution Supplementaire à
                                        l'Apprentissage
                                    </h3>
                                    <v-row
                                        no-gutters
                                        v-if="
                                            bookEntries.contributionSupplementaireALApprentissage
                                                .amount > 0
                                        "
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries
                                                    .contributionSupplementaireALApprentissage
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries
                                                    .contributionSupplementaireALApprentissage
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries
                                                        .contributionSupplementaireALApprentissage
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.taxeSurLesSalaires.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur taxe sur les salaires
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur taxe sur les salaires
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.taxeSurLesSalaires.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.taxeSurLesSalaires
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.taxeSurLesSalaires
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.taxeSurLesSalaires.amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.contributionUniqueALaFormation.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur la Contribution Unique à la Formation
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur la Contribution Unique à la Formation
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.contributionUniqueALaFormation.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.contributionUniqueALaFormation
                                                    .accountableAccountName
                                            }}
                                            + 445860 à
                                            {{
                                                bookEntries.contributionUniqueALaFormation
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionUniqueALaFormation
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                            HT +
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionUniqueALaFormation
                                                        .vatAmount,
                                                    undefined,
                                                )
                                            }}
                                            TVA à
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionUniqueALaFormation
                                                        .grossAmount,
                                                    undefined,
                                                )
                                            }}
                                            TTC
                                        </v-col>
                                    </v-row>

                                    <v-divider :style="styleDialogDivider" />

                                    <h2
                                        v-if="bookEntries.contributionEffortConstruction.amount > 0"
                                        :style="styleDialogProvision"
                                    >
                                        Provisions sur taxe d'apprentissage
                                    </h2>
                                    <h3 v-else :style="styleDialogNoProvision">
                                        Aucune provision sur la Contribution à l'Effort de la
                                        Construction
                                    </h3>

                                    <v-row
                                        no-gutters
                                        v-if="bookEntries.contributionEffortConstruction.amount > 0"
                                    >
                                        <v-col :style="styleDialogCol" />

                                        <v-col :style="styleDialogCol">
                                            {{
                                                bookEntries.contributionEffortConstruction
                                                    .accountableAccountName
                                            }}
                                            à
                                            {{
                                                bookEntries.contributionEffortConstruction
                                                    .thirdPartyAccountableAccountName
                                            }}
                                        </v-col>

                                        <v-col :style="styleDialogCol">
                                            {{
                                                newCommonFormatCurrency(
                                                    bookEntries.contributionEffortConstruction
                                                        .amount,
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer />
                            <v-btn rounded depressed @click="closeDialog"> Annuler </v-btn>

                            <v-btn rounded depressed @click="createPaidHolidaysProvision()">
                                Enregistrer
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </oss-dialog>
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>
                <!-- <AccountingItemEdition
                    v-if="miscellaneousOperationDialog"
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                ></AccountingItemEdition> -->
                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsert="refresh()"
                        :actions="actionsMiscellaneousOperation"
                    />
                </oss-dialog>
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-if="dialogAuditCheckDocumentsManager"
                    v-model="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { sumBy, cloneDeep } from "lodash";
import { Apollo } from "@/decorators";
import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getTextFromStringArray } from "../../../../backend/src/common/audit/auditFunctions";
import { getPayrollTaxesRates } from "../../services/accountingParameters";
import { closedPeriod } from "../../services/audit/AuditServices";

import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import GeneralLedger from "../GeneralLedger2.vue";
import { CheckBase } from "./CheckBase";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import Chat from "../chat/Chat.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";

import { getEmptyDocument } from "../../services/documentServices";
import { DialogAction } from "@/services/dialogAction";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import { getConnectAccountableAccount } from "../../services/accountableAccountServices";
import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import { Component, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        AuditConnectedAcrResults,
        Chat,
        UsersActivitiesHistory,
        AccountingItemEdition2,
    },
})
export class CheckProvisionPaidHolidays extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;

    loading: boolean = false;
    dataLoading: boolean = true;

    dialogAuditCheckDocumentsManager: boolean = false;

    withAccountingPeriod: boolean = false;

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    previousDocumentsIds: Array<string> = [];

    // key: string = "GriL5UI91uGQyObjGxz8Fo5K"

    company: any = {};

    dates: Array<string> = [];
    datesShow: boolean = false;
    differentsDates: boolean = false;
    noResults: boolean = false;

    refreshGeneralLedger = 0;

    longCommentExpand: boolean = false;
    shortCommentExpand: boolean = false;

    longComment: string = "";
    shortComment: string = "";

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    alreadyLinkedDoc: boolean = false;

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, options);
    }

    getTextFromStringArray(array: Array<string>) {
        return getTextFromStringArray(array);
    }

    showProvisions: boolean = false;
    showPayrolls: boolean = false;
    showTaxes: boolean = false;
    showGeneralLedger: boolean = false;

    validatedPayrolls: boolean = false;
    validatedTaxes: boolean = false;
    validated: boolean = false;

    dialog: boolean = false;

    workingBusinessDays: Array<any> = [30, 26, 25];

    paySlips: Array<any> = [];
    paySlipsTaxes: Array<any> = [];
    globalBonus: number = 0.0;

    newPeriodApprentices: boolean = false;

    acrExistingProvisions: Array<any> = [];
    detailedStoredEmployeesData: Array<any> = [];
    resumeStoredEmployeesData: Array<any> = [];
    globalGrossWageProvision: Number = 0;
    globalEmployerContribProvOnGrossWage: Number = 0;
    globalEmployerContribProvOnBonus: Number = 0;

    commentEmployees: string = "";
    commentTaxes: string = "";

    // ***** TAXES *****************
    // *****************************
    taxesPeriodGrossWages: number = 0.0;
    taxeBasis: number = 0.0;
    taxeApprentissage: Boolean = false;
    taxeApprentissageRate: number = getPayrollTaxesRates().taxeApprentissageRate;
    contributionSupplementaireALApprentissageRate: number =
        getPayrollTaxesRates().contributionSupplementaireALApprentissageRate;
    // ** bookEntries[4]
    taxeApprentissageAmount: number = 0.0;
    // ** bookEntries[5]
    contributionSupplementaireALApprentissageAmount: number = 0.0;

    taxeSurLesSalaires: Boolean = false;
    taxeSurLesSalairesRate: number = getPayrollTaxesRates().taxeSurLesSalairesRate;
    // ** bookEntries[6]
    taxeSurLesSalairesAmount: number = 0.0;

    contributionUniqueALaFormation: Boolean = false;
    contributionUniqueALaFormationRate: number =
        getPayrollTaxesRates().contributionUniqueALaFormationRate;
    // ** bookEntries[7]
    contributionUniqueALaFormationAmount: number = 0.0;

    contributionEffortConstruction: Boolean = false;
    contributionEffortConstructionRate: number =
        getPayrollTaxesRates().contributionEffortConstructionRate;
    // ** bookEntries[8]
    contributionEffortConstructionAmount: number = 0.0;

    styleDialogProvision: string = "margin-top: 15px; margin-bottom: 10px;";
    styleDialogNoProvision: string = "margin-top: 15px; margin-bottom: 10px; color: text-primary;";
    styleDialogCol: string = "padding-top: 4px; padding-bottom: 4px;";
    styleDialogDivider: string = "margin-top: 20px;";

    miscellaneousOperationDialog: boolean = false;

    defaultBookEntries: any = {
        grossWageProvision: {
            accountableAccountName: "641200",
            thirdPartyAccountableAccountName: "428200",
            amount: 0,
            wording: "Prov s/CP RTT - SB - ",
        },
        employerContribProvOnGrossWage: {
            accountableAccountName: "645800",
            thirdPartyAccountableAccountName: "438200",
            amount: 0,
            wording: "Prov s/CP RTT - Charges Patronales - ",
        },
        bonusGrossSalary: {
            accountableAccountName: "641300",
            thirdPartyAccountableAccountName: "428600",
            amount: 0,
            wording: "Prov s/Primes Salariés - SB - ",
        },
        employerContribProvOnBonus: {
            accountableAccountName: "645800",
            thirdPartyAccountableAccountName: "438200",
            amount: 0,
            wording: "Prov s/Primes Salariés - Charges Patronales - ",
        },
        taxeApprentissage: {
            accountableAccountName: "633500", // + taxeApprentissage
            thirdPartyAccountableAccountName: "438600",
            amount: 0,
            wording: "Prov s/Taxe d'Apprentissage - Salariés - ",
        },
        contributionSupplementaireALApprentissage: {
            accountableAccountName: "633500", // + contributionSupplementaireALApprentissage
            thirdPartyAccountableAccountName: "438600",
            amount: 0,
            wording: "Prov s/Contribution Supplementaire à l'Apprentissage - Salariés - ",
        },
        taxeSurLesSalaires: {
            accountableAccountName: "631100", // + taxeSurLesSalaires
            thirdPartyAccountableAccountName: "438600",
            amount: 0,
            wording: "Prov s/Taxe sur les Salaires - Salariés - ",
        },
        contributionUniqueALaFormation: {
            accountableAccountName: "633300", // + contributionUniqueALaFormation
            thirdPartyAccountableAccountName: "438600",
            vatRate: 20,
            amount: 0,
            vatAmount: 0,
            grossAmount: 0,
            wording: "Prov s/Contribution Unique à la Formation - Salariés - ",
        },
        contributionEffortConstruction: {
            accountableAccountName: "633400", // + contributionEffortConstruction
            thirdPartyAccountableAccountName: "438600",
            amount: 0,
            wording: "Prov s/Contribution Effort Construction - Salariés - ",
        },
    };

    bookEntries: any = this.defaultBookEntries;

    // +++++++++++++++ HEADERS - PROVISIONS' LIST ++++++++++++++++
    provisionsHeaders: Array<any> = [
        {
            text: "Date",
            value: "date",
            align: "left",
            sortable: true,
        },
        {
            text: "Libellé",
            value: "wording",
            align: "left",
            sortable: true,
        },
        {
            text: "Compte Débit",
            value: "accountableAccountName",
            align: "center",
            sortable: true,
        },
        {
            text: "Compte Crédit",
            value: "accountableAccountName",
            align: "center",
            sortable: true,
        },
        {
            text: "Montant Débit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
        {
            text: "Montant Crédit",
            value: "amountSigned",
            align: "right",
            sortable: true,
        },
    ];

    // +++++++++++++++ HEADERS - EMPLOYEERS' LIST ++++++++++++++++

    apprenticesHeaders: Array<any> = [
        {
            title: "Apprentis présents sur la période sélectionnée",
            value: "employee",
            align: "start",
            sortable: true,
        },
        {
            title: "SB",
            value: "grossWageInNewPeriod",
            align: "start",
            sortable: false,
        },
    ];

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    // afterAccountingPeriodFound() {
    //     if (this.accountingPeriod) {

    //     }
    // }

    // ++++++++++++++++++ PAY SLIPS and AUDIT CHECK RESULT +++++++++++++
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || this.accountingPeriod?.id,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId || !this.accountingPeriod;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.initialiseCompany();
                this.dataLoading = true;
                if (data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.auditItems = data.auditItems.items[0];
                    this.company = this.auditItems.company;

                    // ***** dates for taxes - default
                    this.dates = [
                        this.formatDatePicker(this.accountingPeriod.start),
                        this.formatDatePicker(this.accountingPeriod.end),
                    ];

                    // ++++++ auditCheckResult ++++++++++++++
                    if (this.auditItems.auditCheckResult?.id) {
                        // **** FULL ****
                        this.auditCheckResult = this.auditItems.auditCheckResult;

                        if (this.auditCheckResult.documents?.length) {
                            this.connectedDocuments = this.auditCheckResult.documents;
                        }

                        if (this.auditCheckResult.results?.length) {
                            this.results = this.auditCheckResult.results;
                        }

                        if (this.auditCheckResult.reviewed) {
                            this.reviewed = this.auditCheckResult.reviewed;
                        }

                        if (this.auditCheckResult.data) {
                            // +++++ ACR comments + validates +++++++++
                            if (this.auditCheckResult.data.globals) {
                                const foundedComments = this.auditCheckResult.data.globals;
                                this.validated = foundedComments.validated || false;
                                this.shortComment = foundedComments.shortComment || "";
                                this.longComment = foundedComments.longComment || "";
                            }
                        }
                    }

                    // ++++++ payslips employees +++++++++++++++++++++++++
                    if (this.auditItems.paySlips?.length) {
                        // ++++++ TAXES *****************
                        // ++++++ profile and general settings values
                        if (this.company?.profile) {
                            this.taxeApprentissage = this.company.profile.taxeApprentissage;
                            this.taxeApprentissageRate =
                                getPayrollTaxesRates().taxeApprentissageRate;
                            this.contributionSupplementaireALApprentissageRate =
                                getPayrollTaxesRates().contributionSupplementaireALApprentissageRate;
                            // ** bookEntries[4]
                            this.taxeApprentissageAmount = 0.0;
                            // ** bookEntries[5]
                            this.contributionSupplementaireALApprentissageAmount = 0.0;

                            this.taxeSurLesSalaires = this.company.profile.taxeSurLesSalaires;
                            this.taxeSurLesSalairesRate =
                                getPayrollTaxesRates().taxeSurLesSalairesRate;
                            // ** bookEntries[6]
                            this.taxeSurLesSalairesAmount = 0.0;

                            this.contributionUniqueALaFormation =
                                this.company.profile.contributionUniqueALaFormation;
                            this.contributionUniqueALaFormationRate =
                                getPayrollTaxesRates().contributionUniqueALaFormationRate;
                            // ** bookEntries[7]
                            this.contributionUniqueALaFormationAmount = 0.0;

                            this.contributionEffortConstruction =
                                this.company.profile.contributionEffortConstruction;
                            this.contributionEffortConstructionRate =
                                getPayrollTaxesRates().contributionEffortConstructionRate;
                            // ** bookEntries[8]
                            this.contributionEffortConstructionAmount = 0.0;
                        }

                        // **** EMPLOYEES **********************
                        this.paySlips = this.auditItems.paySlips;

                        this.employeesListHeaders = this.auditItems.employeesListHeaders;
                        this.employeesListHeaders.forEach((element) => {
                            element.title = element.text;
                        });
                        this.computeEmployees();

                        if (this.auditCheckResult) {
                            // ++++++ results previousDocumentsIds ++++++++++
                            if (this.auditCheckResult?.results?.length) {
                                if (this.auditCheckResult.results.length === 1) {
                                    this.previousDocumentsIds = [
                                        this.auditCheckResult.results[0].id,
                                    ];
                                } else {
                                    this.previousDocumentsIds = this.auditCheckResult.results.map(
                                        (rd) => rd.id,
                                    );
                                }
                            }

                            // +++++ ACR.data +++++++++++
                            if (this.auditCheckResult?.data) {
                                // if (this.auditCheckResult.data.employees) {
                                //     // **** data : employees lines **************
                                //     this.detailedStoredEmployeesData = this.auditCheckResult.data.employees
                                // }
                                // +++++ ACR taxRates > customerTaxRates +++++++++

                                if (this.auditCheckResult.data.taxRates) {
                                    const customerTaxRates = this.auditCheckResult.data.taxRates;
                                    this.taxeApprentissageRate =
                                        customerTaxRates.taxeApprentissageRate ||
                                        this.taxeApprentissageRate;

                                    this.contributionSupplementaireALApprentissageRate =
                                        customerTaxRates.contributionSupplementaireALApprentissageRate ||
                                        this.contributionSupplementaireALApprentissageRate;

                                    this.taxeSurLesSalairesRate =
                                        customerTaxRates.taxeSurLesSalairesRate ||
                                        this.taxeSurLesSalairesRate;

                                    this.contributionUniqueALaFormationRate =
                                        customerTaxRates.contributionUniqueALaFormationRate ||
                                        this.contributionUniqueALaFormationRate;

                                    this.contributionEffortConstructionRate =
                                        customerTaxRates.contributionEffortConstructionRate ||
                                        this.contributionEffortConstructionRate;
                                }

                                // +++++ ACR comments + validates +++++++++
                                if (this.auditCheckResult.data.globals) {
                                    const foundedComments = this.auditCheckResult.data.globals;
                                    this.commentEmployees = foundedComments.commentEmployees || "";
                                    this.commentTaxes = foundedComments.commentTaxes || "";
                                    this.validatedPayrolls =
                                        foundedComments.validatedPayrolls || false;
                                    this.validatedTaxes = foundedComments.validatedTaxes || false;
                                    this.differentsDates = foundedComments.differentsDates || false;
                                    // ***** stored dates || accountingPeriod
                                    this.dates = foundedComments.dates || this.dates;
                                }

                                // +++++ ACR taxBooleans > customerTaxBooleans
                                if (this.auditCheckResult.data.taxBooleans) {
                                    const customerTaxBooleans =
                                        this.auditCheckResult.data.taxBooleans;
                                    this.taxeApprentissage =
                                        customerTaxBooleans.taxeApprentissage ||
                                        this.taxeApprentissage;

                                    this.contributionSupplementaireALApprentissage =
                                        customerTaxBooleans.contributionSupplementaireALApprentissage ||
                                        this.contributionSupplementaireALApprentissage;

                                    this.taxeSurLesSalaires =
                                        customerTaxBooleans.taxeSurLesSalaires ||
                                        this.taxeSurLesSalaires;

                                    this.contributionUniqueALaFormation =
                                        customerTaxBooleans.contributionUniqueALaFormation ||
                                        this.contributionUniqueALaFormation;

                                    this.contributionEffortConstruction =
                                        customerTaxBooleans.contributionEffortConstruction ||
                                        this.contributionEffortConstruction;
                                }

                                // ++++++ ACR employees > detailedStoredEmployeesData
                                this.detailedStoredEmployeesData =
                                    this.auditCheckResult.data.employees;

                                // +++++ ACR accountingLines > acrExistingProvisions
                                this.acrExistingProvisions =
                                    this.auditCheckResult.results?.[0]?.accountingLines || [];
                            }

                            if (this.detailedStoredEmployeesData?.length) {
                                this.globalGrossWageProvision = mathFix(
                                    parseFloat(
                                        this.detailedStoredEmployeesData.reduce(
                                            (a, b) => a + (b.grossWageProvision || 0),
                                            0,
                                        ),
                                    ),
                                    0,
                                );

                                this.globalEmployerContribProvOnGrossWage = mathFix(
                                    parseFloat(
                                        this.detailedStoredEmployeesData.reduce(
                                            (a, b) => a + (b.employerContribProvOnGrossWage || 0),
                                            0,
                                        ),
                                    ),
                                    0,
                                );

                                this.globalBonus = mathFix(
                                    parseFloat(
                                        this.detailedStoredEmployeesData.reduce(
                                            (a, b) => a + (b.bonus || 0),
                                            0,
                                        ),
                                    ),
                                );

                                this.globalEmployerContribProvOnBonus = mathFix(
                                    parseFloat(
                                        this.detailedStoredEmployeesData.reduce(
                                            (a, b) => a + (b.employerContribProvOnBonus || 0),
                                            0,
                                        ),
                                    ),
                                    0,
                                );
                            }

                            // **** resumeStoredEmployeesData : initial values
                            this.resumeStoredEmployeesData = [
                                { amount: this.globalGrossWageProvision },
                                { amount: this.globalEmployerContribProvOnGrossWage },
                                { amount: this.globalBonus },
                                { amount: this.globalEmployerContribProvOnBonus },
                            ];

                            // **** bookEntries : previously booked - to modify
                            this.bookEntries.grossWageProvision.amount =
                                this.globalGrossWageProvision;
                            this.bookEntries.employerContribProvOnGrossWage.amount =
                                this.globalEmployerContribProvOnGrossWage;
                            this.bookEntries.bonusGrossSalary.amount = this.globalBonus;
                            this.bookEntries.employerContribProvOnBonus.amount =
                                this.globalEmployerContribProvOnBonus;
                            this.bookEntries.taxeApprentissage.amount =
                                this.taxeApprentissageAmount;
                            this.bookEntries.contributionSupplementaireALApprentissage.amount =
                                this.contributionSupplementaireALApprentissageAmount;
                            this.bookEntries.taxeSurLesSalaires.amount =
                                this.taxeSurLesSalairesAmount;
                            this.bookEntries.contributionUniqueALaFormation.amount =
                                this.contributionUniqueALaFormationAmount;
                            this.bookEntries.contributionEffortConstruction.amount =
                                this.contributionEffortConstructionAmount;

                            this.computeEmployees();
                            this.changeTaxesProvision();
                        }

                        // this.computeEmployees();
                    } else {
                        this.noResults = true;
                    }
                } else {
                    this.paySlips = [];
                    this.employees = [];
                }
                this.dataLoading = false;
            } else {
                this.paySlips = [];
                this.employees = [];
            }
        },
    })
    auditItems: any;

    employeesListHeaders: Array<any>;

    reviewed: number = 0;

    // ++++++++++++++ UPSERT +++++++++++++++
    async createPaidHolidaysProvision(action = "UPDATE") {
        if (action === "REVIEW") {
            console.error(
                "createPaidHolidaysProvision action === 'REVIEW' : TODO\n basic upsert to do, changing only the reviewed value\n to factorize on CheckBase and to be used on all checks",
            );
            debugger;
        }
        if (this.validatedPayrolls) {
            if (this.employees.length) {
                for (const empl of this.employees) {
                    empl.validated = true;
                }
            }
        }

        const data: any = {};
        const documents = [];
        if (!this.employees.length) {
            this.validatedPayrolls = true;
            this.validatedTaxes = true;
            this.validated = true;
        } else {
            if (Object.keys(this.bookEntries).length > 0) {
                // ***** accountingLines ***********

                // ***** employees
                data.employees = cloneDeep(this.employees) || [];

                const accountingLines = [];
                const periodYear = moment(this.accountingPeriod.end).format("YYYY");

                const alDate = this.accountingPeriod.end;

                for (const key in this.bookEntries) {
                    const be = this.bookEntries[key];
                    const alGeneric = {
                        date: alDate,
                        wording: be.wording + periodYear,
                    };

                    if (be.amount && be.amount !== 0) {
                        // ***** accountingLines ***********
                        // ** if vatRate
                        if (be.vatRate) {
                            be.netAmountSigned = mathFix(be.amount, 0);
                            be.vatAmountSigned = mathFix((be.amount * be.vatRate) / 100, 2);
                            be.grossAmountSigned = -mathFix(
                                be.netAmountSigned + be.vatAmountSigned,
                                2,
                            );

                            // ***********************************
                            // ****** VAT - 3 lines **************
                            const aLObject6: any = {
                                amountSigned: 0,
                                amount: 0,
                                accountableAccount: {},
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };

                            const aLObjectVAT: any = {
                                amountSigned: 0,
                                amount: 0,
                                accountableAccount: {},
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };

                            const aLObject4: any = {
                                amountSigned: 0,
                                amount: 0,
                                accountableAccount: {},
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };

                            // *** c/6 - netAmount
                            aLObject6.amountSigned = be.netAmountSigned
                                ? be.netAmountSigned
                                : undefined;
                            aLObject6.amount = aLObject6.amountSigned;
                            aLObject6.accountableAccount = await getConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                be.accountableAccountName,
                            );
                            accountingLines.push({ ...alGeneric, ...aLObject6 });

                            aLObjectVAT.amountSigned = be.vatAmountSigned
                                ? be.vatAmountSigned
                                : undefined;
                            aLObjectVAT.amount = aLObjectVAT.amountSigned;
                            aLObjectVAT.accountableAccount = await getConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                "445860",
                            );
                            accountingLines.push({ ...alGeneric, ...aLObjectVAT });

                            // *** c/4 - grossAmount
                            aLObject4.amountSigned = be.grossAmountSigned
                                ? be.grossAmountSigned
                                : undefined;
                            aLObject4.amount = -aLObject4.amountSigned;
                            // eslint-disable-next-line no-await-in-loop
                            aLObject4.accountableAccount = await getConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                be.thirdPartyAccountableAccountName,
                                undefined,
                                undefined,
                                true,
                            );
                            accountingLines.push({ ...alGeneric, ...aLObject4 });
                        } else {
                            // **********************************
                            // ******* no VAT - 2 lines *********
                            const aLObject6: any = {
                                amountSigned: 0,
                                amount: 0,
                                accountableAccount: {},
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };
                            const aLObject4: any = {
                                amountSigned: 0,
                                amount: 0,
                                accountableAccount: {},
                                company: { connect: { id: this.companyId } },
                                type: "ACCOUNTING",
                            };
                            // *** c/6
                            aLObject6.amountSigned = be.amount ? mathFix(be.amount, 0) : undefined;
                            aLObject6.amount = aLObject6.amountSigned;

                            aLObject6.accountableAccount = await getConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                be.accountableAccountName,
                            );
                            accountingLines.push({ ...alGeneric, ...aLObject6 });

                            // *** c/4
                            aLObject4.amountSigned = be.amount ? -mathFix(be.amount, 0) : undefined;
                            aLObject4.amount = -aLObject4.amountSigned;
                            // eslint-disable-next-line no-await-in-loop
                            aLObject4.accountableAccount = await getConnectAccountableAccount(
                                this.$store,
                                this.$apollo,
                                be.thirdPartyAccountableAccountName,
                                undefined,
                                undefined,
                                true,
                            );
                            accountingLines.push({ ...alGeneric, ...aLObject4 });
                        }
                    }
                }

                if (accountingLines?.length) {
                    const document: any = getEmptyDocument(
                        this.companyId,
                        "Provision sur CP, RTT, primes et taxes",
                        "MISCELLANEOUS_OPERATION",
                        alDate,
                        this.currentUser.id,
                        null,
                        accountingLines,
                        true,
                    );
                    // document.data = {
                    //     accountingLines: data[1].accountingLines
                    // }
                    documents.push(document);
                }

                // ****** data[2] taxRates
                data.taxRates = {
                    taxeApprentissageRate:
                        this.taxeApprentissageRate ||
                        getPayrollTaxesRates().taxeApprentissageRate ||
                        undefined,
                    contributionSupplementaireALApprentissageRate:
                        this.contributionSupplementaireALApprentissageRate ||
                        getPayrollTaxesRates().contributionSupplementaireALApprentissageRate ||
                        0,
                    taxeSurLesSalairesRate:
                        this.taxeSurLesSalairesRate ||
                        getPayrollTaxesRates().taxeSurLesSalairesRate ||
                        0,
                    contributionUniqueALaFormationRate:
                        this.contributionUniqueALaFormationRate ||
                        getPayrollTaxesRates().contributionUniqueALaFormationRate ||
                        0,
                    contributionEffortConstructionRate:
                        this.contributionEffortConstructionRate ||
                        getPayrollTaxesRates().contributionEffortConstructionRate ||
                        0,
                };

                // ***** data[3] taxBooleans
                if (this.company && this.company.profile) {
                    data.taxBooleans = {
                        taxeApprentissage:
                            this.taxeApprentissage || this.company.profile.taxeApprentissage,
                        taxeSurLesSalaires:
                            this.taxeSurLesSalaires || this.company.profile.taxeSurLesSalaires,
                        contributionUniqueALaFormation:
                            this.contributionUniqueALaFormation ||
                            this.company.profile.contributionUniqueALaFormation,
                        contributionEffortConstruction:
                            this.contributionEffortConstruction ||
                            this.company.profile.contributionEffortConstruction,
                    };
                }
            }
        }

        // ***** data[4] commentEmployees commentTaxes validatedPayrolls validatedTaxes differentsDates dates
        data.globals = {
            commentEmployees: this.commentEmployees,
            commentTaxes: this.commentTaxes,
            validatedPayrolls: this.validatedPayrolls,
            validatedTaxes: this.validatedTaxes,
            validated: this.validated,
            differentsDates: this.differentsDates,
            dates: this.dates,
            shortComment: this.shortComment,
            longComment: this.longComment,
        };

        if (this.acKey && this.companyId && this.accountingPeriodId && data) {
            const auditCheckResultVariables = {
                id: this.auditCheckResult?.id || "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: this.validated ? "VALIDATED" : "EDITION",
                // thirdPartyCompanyCreate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                // thirdPartyCompanyUpdate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                deleteDocuments: this.previousDocumentsIds || [],
                documents: documents || undefined,
                data: JSON.parse(JSON.stringify(data)),
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
                reviewed: this.reviewed,
            };

            try {
                await this.$apollo.mutate({
                    mutation: UPSERT_AUDIT_CHECK_RESULT,
                    variables: auditCheckResultVariables,
                });
            } catch (error) {
                console.error(error);
                debugger;
            }

            this.refresh();
            this.refreshGeneralLedger++;

            // await this.createUserActivity(action) // deprecated

            // ++++++++++++++ RESET +++++++++++++++++++
            this.dialog = false;

            this.refresh();

            this.refreshGeneralLedger++;
        }

        // await Promise.all(results);
    }

    refresh() {
        if (this.$apollo.queries?.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            debugger;
        }
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async validateFunction() {
        if (!this.validated) {
            this.validatedPayrolls = true;
            this.validatedTaxes = true;
            this.validated = !this.validated;
            await this.createPaidHolidaysProvision("VALIDATE");
        } else {
            this.validatedPayrolls = false;
            this.validatedTaxes = false;
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.createPaidHolidaysProvision("UPDATE");
        }
    }

    // computeAccountingPeriodText(accountingPeriod) {
    //     let text = moment(accountingPeriod.start).format("DD-MM-YYYY");
    //     text += " / ";
    //     text += moment(accountingPeriod.end).format("DD-MM-YYYY");
    //     return text;
    // }

    // get accountingPeriodId() {
    //     if (this.withAccountingPeriod && this.accountingPeriod) return this.accountingPeriod.id
    //     if (this.$route.params.accountingPeriodId) return this.$route.params.accountingPeriodId;
    //     return undefined
    // }

    // ++++++++ PROVISION DATE ++++++++++++++
    get provisionDate() {
        let lastDayOfMonth = "";
        if (this.paySlips && this.paySlips.length > 0) {
            // **** DIFFERENTS .sort date ****
            // + OK
            // const sortDate = this.paySlips.sort((a, b) => new moment(a.date).format('YYYYMMDD') - new moment(b.date).format('YYYYMMDD'))

            // + OK
            // const sortDate = this.paySlips.sort((a, b) => parseInt(moment(a.date).format('YYYYMMDD'), 10) - parseInt(moment(b.date).format('YYYYMMDD'), 10))

            // + OK
            // const sortDate = this.paySlips.sort((a, b) => moment(a.date).diff(moment(b.date)))

            // + OK
            // const sortDate = this.paySlips.sort((a, b) => new Date(a.date) - new Date(b.date))

            // + NO NEED OF "const sortDate = ""
            const sortDate = this.paySlips.sort((a, b) => {
                if (a.date < b.date) return -1;
                if (a.date > b.date) return 1;
                return 0;
            });

            const lastDate = sortDate[sortDate.length - 1].date;
            lastDayOfMonth = moment(lastDate).endOf("month").format();
        }
        return lastDayOfMonth;
    }

    // ++++++++ GLOBAL GROSS WAGE +++++++++++
    get globalsGrossWages() {
        const grossWagesList = [];
        if (this.paySlips && this.paySlips.length > 0) {
            for (const paySlip of this.paySlips) {
                // ***** AccountingLines ***********
                if (paySlip.accountingLines) {
                    for (const accountingLine of paySlip.accountingLines) {
                        if (
                            accountingLine.wording &&
                            accountingLine.accountableAccount &&
                            accountingLine.accountableAccount.name &&
                            (accountingLine.accountableAccount.name.startsWith("641000") ||
                                accountingLine.accountableAccount.name.startsWith("641100") ||
                                accountingLine.accountableAccount.name.startsWith("641200") ||
                                accountingLine.accountableAccount.name.startsWith("641400") ||
                                accountingLine.accountableAccount.name.startsWith("641450") ||
                                accountingLine.accountableAccount.name.startsWith("641600"))

                            // // /////////////////////////////////////////
                            // // //// EN ATTENTE CONFIRMATION CHRISTINE
                            // // //// DES COMPTES A SELECTIONNER
                            // // /////////////////////////////////////////////
                        ) {
                            grossWagesList.push({
                                month:
                                    accountingLine.wording ||
                                    "SAL " + moment(paySlip.date).format("MM-YYYY"),
                                amountSigned: accountingLine.amountSigned,
                                accountableAccountName: accountingLine.accountableAccount.name,
                            });
                        }
                    }
                }
            }
            // return grossWagesList
        }
        // ************************************
        const gWSum = sumBy(grossWagesList, "amountSigned");
        return gWSum;
    }

    // ++++++++ GLOBAL NET SALARY +++++++++++
    get globalNetSalary() {
        const netSalariesList = [];
        let nSList: any = 0;
        if (this.paySlips && this.paySlips.length > 0) {
            for (const paySlip of this.paySlips) {
                // ***** AccountingLines ************
                if (paySlip.accountingLines) {
                    for (const accountingLine of paySlip.accountingLines) {
                        if (
                            accountingLine.wording &&
                            accountingLine.accountableAccount &&
                            accountingLine.accountableAccount.name &&
                            accountingLine.accountableAccount.name.startsWith("421000")
                        ) {
                            netSalariesList.push({
                                month: accountingLine.wording,
                                amountSigned: accountingLine.amountSigned,
                            });
                            // } else {
                            //     return netSalariesList
                        }
                    }
                }
            }
        }
        // **********************************

        nSList = mathFix(
            parseFloat(netSalariesList.reduce((a, b) => a + (b.amountSigned || 0), 0)),
            4,
        );
        return nSList;
    }

    // ++++++++ GLOBALS EMPLOYER'S CONTRIBUTIONS +++++++++++
    get globalsEmployersContributions() {
        const employersContributionsList = [];
        let eCList: any = 0;
        if (this.paySlips && this.paySlips.length > 0) {
            for (const paySlip of this.paySlips) {
                // ***** AccountingLines ***********
                if (paySlip.accountingLines) {
                    for (const accountingLine of paySlip.accountingLines) {
                        if (
                            accountingLine.wording &&
                            accountingLine.accountableAccount &&
                            accountingLine.accountableAccount.name &&
                            accountingLine.accountableAccount.name.startsWith("645")
                        ) {
                            // // 6458 is on provisions !
                            if (!accountingLine.accountableAccount.name.startsWith("6458")) {
                                employersContributionsList.push({
                                    month: accountingLine.wording,
                                    accountableAccountName: accountingLine.accountableAccount.name,
                                    amountSigned: accountingLine.amountSigned,
                                });
                            }
                        }
                    }
                } else {
                    return employersContributionsList;
                }
            }
        }
        eCList = mathFix(employersContributionsList.reduce((a, b) => a + (b.amountSigned || 0), 0));
        return eCList;
    }

    // ++++++++ GLOBALS RATE EMPLOYER'S CONTRIBUTIONS +++++++++++
    get globalRateEmployersContribution() {
        let globalRate: any = 0;
        if (this.globalsGrossWages && this.globalsEmployersContributions) {
            globalRate = mathFix(
                (this.globalsEmployersContributions * 100) / this.globalsGrossWages,
            );
        }
        return globalRate;
    }

    employees = [];

    // ++++++++ DETAILLED EMPLOYEES' LIST +++++++++++
    computeEmployees() {
        const detailedEmployeesList = [];
        const employeeDetails = [];

        if (this.paySlips && this.paySlips.length > 0) {
            for (const paySlip of this.paySlips) {
                // ***** AccountingLines ***********
                if (paySlip.accountingLines) {
                    // ***** employees name + individual monthly netSalary
                    for (const accountingLine of paySlip.accountingLines) {
                        if (
                            accountingLine.wording &&
                            accountingLine.accountableAccount &&
                            accountingLine.accountableAccount.name &&
                            accountingLine.accountableAccount.name.startsWith("421000") &&
                            accountingLine.user &&
                            accountingLine.user.id &&
                            (accountingLine.user.lastname || accountingLine.user.firstname) &&
                            accountingLine.amountSigned !== 0
                        ) {
                            detailedEmployeesList.push({
                                month: accountingLine.date,
                                user: {
                                    id: accountingLine.user.id,
                                    lastName: accountingLine.user.lastname,
                                    firstName: accountingLine.user.firstname,
                                },
                                netSalary: accountingLine.amountSigned,
                            });
                        }
                    }
                } else {
                    this.employees = detailedEmployeesList;
                    return;
                }
            }
        }

        for (let el = 0; el < detailedEmployeesList.length; el++) {
            // ** SEARCH FOR EXISTING EMPLOYEES
            let employeeDetail = employeeDetails.find((ed) =>
                detailedEmployeesList[el].owner && detailedEmployeesList[el].owner.id
                    ? ed.employee.id === detailedEmployeesList[el].owner.id
                    : detailedEmployeesList[el].user && detailedEmployeesList[el].user.id
                      ? ed.employee.id === detailedEmployeesList[el].user.id
                      : undefined,
            );
            // ** NEW EMPLOYEE
            if (!employeeDetail) {
                employeeDetail = {
                    employee: detailedEmployeesList[el].user
                        ? detailedEmployeesList[el].user
                        : detailedEmployeesList[el].owner
                          ? detailedEmployeesList[el].owner
                          : undefined,
                    netSalarySum: 0,
                    paySlipsCount: 1,
                    workingMonths: [],
                    month: detailedEmployeesList[el].month,
                };
                employeeDetails.push(employeeDetail);
            }
            // ** EXISTING EMPLOYEE
            employeeDetail.netSalarySum += detailedEmployeesList[el].netSalary
                ? detailedEmployeesList[el].netSalary
                : 0;
            employeeDetail.paySlipsCount =
                employeeDetail.month !== detailedEmployeesList[el].month
                    ? employeeDetail.paySlipsCount + 1
                    : employeeDetail.paySlipsCount;
            employeeDetail.workingMonths.push(detailedEmployeesList[el].month);
            employeeDetail.month =
                employeeDetail.month !== detailedEmployeesList[el].month
                    ? detailedEmployeesList[el].month
                    : employeeDetail.month;
        }

        for (const employee of employeeDetails) {
            if (this.detailedStoredEmployeesData && this.detailedStoredEmployeesData.length > 0) {
                const detailedExistingProvisionsEmployee = this.detailedStoredEmployeesData.find(
                    (empl) => empl.employee.id === employee.employee.id,
                );

                employee.approxOrRealSwitch =
                    detailedExistingProvisionsEmployee.approxOrRealSwitch || false;

                employee.realGrossWages = detailedExistingProvisionsEmployee.realGrossWages || 0;

                employee.realEmployerContributions =
                    detailedExistingProvisionsEmployee.realEmployerContributions || 0;

                employee.realEarnedPaidHolidays =
                    detailedExistingProvisionsEmployee.realEarnedPaidHolidays || 0;

                employee.apprentice = detailedExistingProvisionsEmployee.apprentice || false;
                employee.apprenticesInPeriod = false;
                employee.grossWageInNewPeriod =
                    detailedExistingProvisionsEmployee.grossWageInNewPeriod || 0;

                employee.usedRate =
                    employee.realGrossWages && employee.realEmployerContributions
                        ? mathFix(
                              (employee.realEmployerContributions * 100) / employee.realGrossWages,
                              2,
                          )
                        : mathFix(this.globalRateEmployersContribution, 2);

                employee.balancePaidHolidays =
                    detailedExistingProvisionsEmployee.balancePaidHolidays;
                employee.balanceRTT = detailedExistingProvisionsEmployee.balanceRTT;
                employee.daysTypes = detailedExistingProvisionsEmployee.daysTypes;
                employee.grossWageProvision = detailedExistingProvisionsEmployee.grossWageProvision;
                employee.employerContribProvOnGrossWage =
                    detailedExistingProvisionsEmployee.employerContribProvOnGrossWage;
                employee.bonus = detailedExistingProvisionsEmployee.bonus;
                employee.employerContribProvOnBonus =
                    detailedExistingProvisionsEmployee.employerContribProvOnBonus;
                employee.validated = detailedExistingProvisionsEmployee.validated || false;
                // employee.profitsSharing = 0
                // employee.participation = 0
            } else {
                employee.balancePaidHolidays = 0;
                employee.balanceRTT = 0;
                employee.daysTypes = 30;
                employee.bonus = 0;
                employee.grossWageProvision = 0;
                employee.employerContribProvOnBonus = 0;
            }

            if (
                this.globalsGrossWages !== 0 &&
                this.globalNetSalary !== 0 &&
                employee.netSalarySum !== 0 &&
                this.globalRateEmployersContribution !== 0
            ) {
                employee.netSalarySum = mathFix(-employee.netSalarySum);

                employee.grossWagesApprox = mathFix(
                    (-this.globalsGrossWages * employee.netSalarySum) / this.globalNetSalary,
                );

                employee.oneDayGrossWage = this.employeeOneDayGrossWage(employee);
            }
        }

        const someApprentice = employeeDetails.find((ed) => ed.apprentice);
        if (someApprentice) {
            this.changeTaxesProvision();
        }
        this.employees = employeeDetails;
    }

    changeTaxesProvision() {
        if (this.dates.length === 2 && this.paySlips.length) {
            const manualStartDate = moment(this.dates[0]).startOf("day").format("YYYY-MM-DD");
            const manualEndDate = moment(this.dates[1]).endOf("day").format("YYYY-MM-DD");

            if (
                manualStartDate != moment(this.accountingPeriod.start).format("YYYY-MM-DD") ||
                manualEndDate != moment(this.accountingPeriod.end).format("YYYY-MM-DD")
            ) {
                this.differentsDates = true;
            } else {
                this.differentsDates = false;
            }

            // ** find apprentices in period
            if (this.employees.length) {
                for (const employee of this.employees) {
                    if (employee.apprentice) {
                        const wms = [...new Set(employee.workingMonths)];
                        const apprenticesInPeriod = wms.find(
                            (month) => month >= manualStartDate && month <= manualEndDate,
                        );
                        if (apprenticesInPeriod) {
                            employee.apprenticesInPeriod = true;
                        }
                        this.newPeriodApprentices = true;
                    }
                }
            }

            const dateToDate641 = [];

            for (const paySlip of this.paySlips) {
                if (
                    moment(paySlip.date).startOf("day").format("YYYY-MM-DD") >= manualStartDate &&
                    moment(paySlip.date).startOf("day").format("YYYY-MM-DD") <= manualEndDate
                ) {
                    // ***** AccountingLines ***********
                    if (paySlip.accountingLines) {
                        for (const accountingLine of paySlip.accountingLines) {
                            const amount641 = {
                                month: paySlip.date,
                                grossAmount: 0.0,
                                accountableAccountName: "",
                            };
                            if (
                                accountingLine.wording &&
                                accountingLine.accountableAccount &&
                                accountingLine.accountableAccount.name &&
                                (accountingLine.accountableAccount.name.startsWith("641000") ||
                                    accountingLine.accountableAccount.name.startsWith("641100") ||
                                    accountingLine.accountableAccount.name.startsWith("641200") ||
                                    accountingLine.accountableAccount.name.startsWith("641400") ||
                                    accountingLine.accountableAccount.name.startsWith("641450") ||
                                    accountingLine.accountableAccount.name.startsWith("641600"))
                            ) {
                                amount641.grossAmount = accountingLine.amountSigned;
                                amount641.accountableAccountName =
                                    accountingLine.accountableAccount.name;
                            }
                            if (amount641.grossAmount !== 0) {
                                dateToDate641.push(amount641);
                            }
                        }
                    }
                }
            }

            this.taxeBasis = mathFix(
                dateToDate641.reduce((a, b) => a + b.grossAmount, 0),
                2,
            );
            this.taxesPeriodGrossWages = this.taxeBasis;

            if (this.newPeriodApprentices) {
                for (const apprentice of this.employees) {
                    if (
                        apprentice.apprenticesInPeriod &&
                        apprentice.grossWageInNewPeriod &&
                        apprentice.grossWageInNewPeriod !== 0
                    ) {
                        this.taxeBasis -= apprentice.grossWageInNewPeriod;
                    }
                }
            }
        } else {
            this.newPeriodApprentices = false;
            this.taxeBasis = this.globalsGrossWages;

            for (const e of this.employees) {
                // ** e.realGrossWages: manual amount
                if (e.apprentice && e.approxOrRealSwitch && e.realGrossWages) {
                    this.taxeBasis -= e.realGrossWages;
                } else if (e.apprentice) {
                    this.taxeBasis -= e.grossWagesApprox;
                }
            }
        }

        if (this.taxeBasis) {
            if (this.taxeApprentissage) {
                this.taxeApprentissageAmount = mathFix(
                    (this.taxeBasis * this.taxeApprentissageRate) / 100,
                    0,
                );
                this.contributionSupplementaireALApprentissageAmount = mathFix(
                    (this.taxeBasis * this.contributionSupplementaireALApprentissageRate) / 100,
                    0,
                );
            } else {
                this.taxeApprentissageAmount = 0.0;
                this.contributionSupplementaireALApprentissageAmount = 0.0;
            }

            if (this.taxeSurLesSalaires) {
                this.taxeSurLesSalairesAmount = mathFix(
                    (this.taxeBasis * this.taxeSurLesSalairesRate) / 100,
                    0,
                );
            } else {
                this.taxeSurLesSalairesAmount = 0.0;
            }

            if (this.contributionUniqueALaFormation) {
                this.contributionUniqueALaFormationAmount = mathFix(
                    (this.taxeBasis * this.contributionUniqueALaFormationRate) / 100,
                    0,
                );
            } else {
                this.contributionUniqueALaFormationAmount = 0.0;
            }

            if (this.contributionEffortConstruction) {
                this.contributionEffortConstructionAmount = mathFix(
                    (this.taxeBasis * this.contributionEffortConstructionRate) / 100,
                    0,
                );
            } else {
                this.contributionEffortConstructionAmount = 0.0;
            }

            this.bookEntries.taxeApprentissage.amount = this.taxeApprentissageAmount;
            this.bookEntries.contributionSupplementaireALApprentissage.amount =
                this.contributionSupplementaireALApprentissageAmount;
            this.bookEntries.taxeSurLesSalaires.amount = this.taxeSurLesSalairesAmount;
            this.bookEntries.contributionUniqueALaFormation.amount =
                this.contributionUniqueALaFormationAmount;
            this.bookEntries.contributionUniqueALaFormation.vatAmount = mathFix(
                (this.contributionUniqueALaFormationAmount *
                    this.bookEntries.contributionUniqueALaFormation.vatRate) /
                    100,
                2,
            );
            this.bookEntries.contributionUniqueALaFormation.grossAmount =
                this.contributionUniqueALaFormationAmount +
                this.bookEntries.contributionUniqueALaFormation.vatAmount;
            this.bookEntries.contributionEffortConstruction.amount =
                this.contributionEffortConstructionAmount;
        }
    }

    employeeOneDayGrossWage(employee) {
        const result =
            employee.approxOrRealSwitch &&
            employee.realGrossWages &&
            employee.realEarnedPaidHolidays
                ? mathFix((employee.realGrossWages * 0.1) / employee.realEarnedPaidHolidays, 2)
                : mathFix(
                      (employee.grossWagesApprox * 0.1) /
                          (employee.paySlipsCount / 12) /
                          employee.daysTypes,
                      2,
                  );
        return (employee.oneDayGrossWage = result || 0);
    }

    changeProvision(employee) {
        if (employee.grossWagesApprox && employee.approxOrRealSwitch) {
            employee.usedRate =
                employee.realGrossWages && employee.realEmployerContributions
                    ? mathFix(
                          (employee.realEmployerContributions * 100) / employee.realGrossWages,
                          2,
                      )
                    : mathFix(this.globalRateEmployersContribution, 2);

            employee.employerContribProvOnBonus = mathFix(
                (employee.bonus * employee.usedRate) / 100,
                0,
            );

            employee.oneDayGrossWage = this.employeeOneDayGrossWage(employee);

            // (employee.approxOrRealSwitch && employee.realGrossWages && employee.realEmployerContributions && employee.realEarnedPaidHolidays) ? mathFix((employee.realGrossWages) / employee.paySlipsCount * 12 * 0.1 / employee.daysTypes, 2) : mathFix((employee.grossWagesApprox) / employee.paySlipsCount * 12 * 0.1 / employee.daysTypes, 2)

            if (employee.oneDayGrossWage) {
                let provisionPaidHolidays = 0.0;
                let provisionRTT = 0.0;

                provisionPaidHolidays = mathFix(
                    employee.balancePaidHolidays * employee.oneDayGrossWage,
                    0,
                );

                provisionRTT = mathFix(employee.balanceRTT * employee.oneDayGrossWage, 0);

                employee.grossWageProvision = mathFix(provisionPaidHolidays + provisionRTT, 0);

                employee.employerContribProvOnGrossWage = mathFix(
                    (employee.grossWageProvision * employee.usedRate) / 100,
                    0,
                );
            }
        } else {
            employee.usedRate = mathFix(this.globalRateEmployersContribution, 2);

            employee.employerContribProvOnBonus = mathFix(
                (employee.bonus * employee.usedRate) / 100,
                0,
            );

            employee.oneDayGrossWage = this.employeeOneDayGrossWage(employee);

            // (employee.approxOrRealSwitch && employee.realGrossWages && employee.realEmployerContributions && employee.realEarnedPaidHolidays) ? mathFix((employee.realGrossWages) / employee.paySlipsCount * 12 * 0.1 / employee.daysTypes, 2) : mathFix((employee.grossWagesApprox) / employee.paySlipsCount * 12 * 0.1 / employee.daysTypes, 2)

            if (employee.oneDayGrossWage) {
                let provisionPaidHolidays = 0.0;
                let provisionRTT = 0.0;

                provisionPaidHolidays = mathFix(
                    employee.balancePaidHolidays * employee.oneDayGrossWage,
                    0,
                );

                provisionRTT = mathFix(employee.balanceRTT * employee.oneDayGrossWage, 0);

                employee.grossWageProvision = mathFix(provisionPaidHolidays + provisionRTT, 0);

                employee.employerContribProvOnGrossWage = mathFix(
                    (employee.grossWageProvision * employee.usedRate) / 100,
                    0,
                );
            }
        }

        this.globalBonus = mathFix(sumBy(this.employees, "bonus"), 2);
        this.globalEmployerContribProvOnBonus = mathFix(
            sumBy(this.employees, "employerContribProvOnBonus"),
            2,
        );

        this.globalGrossWageProvision = mathFix(sumBy(this.employees, "grossWageProvision"), 2);
        this.globalEmployerContribProvOnGrossWage = mathFix(
            sumBy(this.employees, "employerContribProvOnGrossWage"),
            2,
        );

        this.bookEntries.grossWageProvision.amount = this.globalGrossWageProvision;
        this.bookEntries.employerContribProvOnGrossWage.amount =
            this.globalEmployerContribProvOnGrossWage;
        this.bookEntries.bonusGrossSalary.amount = this.globalBonus;
        this.bookEntries.employerContribProvOnBonus.amount = this.globalEmployerContribProvOnBonus;

        this.changeTaxesProvision();
    }

    // ***************** DELETE ACR **********************
    async deleteAuditCheckResult(acrId) {
        if (acrId) {
            const deleted = await this.$apollo.mutate({
                mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
                variables: { id: acrId } || {},
            });

            if (deleted) {
                // await this.createUserActivity("DELETE") // deprecated

                this.refresh();
            }
        }
    }

    async closeDialog() {
        this.dialog = false;
    }

    sumField(key) {
        // sum data in give key (property)
        if (this.employees && this.employees.length > 0) {
            return this.employees.reduce((a, b) => a + (b[key] || 0), 0);
        }
        return 0;
    }

    sumFieldGrossWages(approxOrRealSwitch) {
        if (this.employees && this.employees.length > 0) {
            let grossWagesSums = 0;
            for (const e of this.employees) {
                if (e.approxOrRealSwitch) {
                    grossWagesSums += e.realGrossWages;
                } else {
                    grossWagesSums += e.grossWagesApprox;
                }
            }
            return grossWagesSums;
        }
        return 0;
    }

    sumFieldEmployerContributions(approxOrRealSwitch) {
        if (this.employees && this.employees.length > 0) {
            let employerContributionsSums = 0;
            for (const e of this.employees) {
                if (e.approxOrRealSwitch) {
                    employerContributionsSums += e.realEmployerContributions;
                }
            }
            return employerContributionsSums;
        }
        return 0;
    }

    // aaExpand(itemToExpand) {
    //     // this.showPayrolls = !this.showPayrolls
    //     itemToExpand = !itemToExpand
    // }

    initialiseCompany() {
        this.showProvisions = false;
        this.auditItems = [];
        this.paySlips = [];
        this.employees = [];
        this.previousDocumentsIds = [];
        this.auditCheckResult = {};
        this.detailedStoredEmployeesData = [];
        this.acrExistingProvisions = [];
        this.bookEntries = this.defaultBookEntries;
        this.differentsDates = false;
        this.noResults = false;
        this.validated = false;
        this.validatedPayrolls = false;
        this.validatedTaxes = false;
    }

    get wagesCond() {
        if (
            this.bookEntries.grossWageProvision.amount > 0 ||
            this.bookEntries.bonusGrossSalary.amount > 0
        ) {
            return true;
        }
        return false;
    }

    get taxesCond() {
        if (
            this.bookEntries.taxeApprentissage.amount > 0 ||
            this.bookEntries.contributionSupplementaireALApprentissage.amount > 0 ||
            this.bookEntries.taxeSurLesSalaires.amount > 0 ||
            this.bookEntries.contributionUniqueALaFormation.amount > 0 ||
            this.bookEntries.contributionEffortConstruction.amount > 0
        ) {
            return true;
        }
        return false;
    }

    // firstPeriodDateChange(date) {
    //     this.firstPeriodStart = date.begin;
    //     this.firstPeriodEnd = date.end;
    // }

    onDateRangeChanged(data) {
        debugger;
        this.dates[0] = this.formatDatePicker(data.begin);
        this.dates[1] = this.formatDatePicker(data.end);
        this.changeTaxesProvision();
    }

    validate() {
        this.validated = true;
        this.validatedPayrolls = true;
        this.validatedTaxes = true;
    }

    invalidate() {
        this.validated = false;
        this.validatedPayrolls = false;
        this.validatedTaxes = false;

        if (this.employees.length) {
            for (const emp of this.employees) {
                if (emp.validated) {
                    emp.validated = false;
                }
            }
        }
        this.createPaidHolidaysProvision("UPDATE");
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
    }
}

export default toNative(CheckProvisionPaidHolidays);
</script>
